import React from 'react';
import { Button } from '@material-ui/core';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import styled from 'styled-components';
const FlexContainer = styled.div `
    display: flex;
    padding: 0.5rem;
`;
const PreviousButtonContainer = styled.div `
    flex: 1;
    display: flex;
    justify-content: flex-start;
`;
const NextButtonContainer = styled.div `
    flex: 1;
    display: flex;
    justify-content: flex-end;
`;
const PageDetails = styled.div `
    flex: 1;
    text-align: center;
    margin: auto;

    p {
        color: ${(props) => props.theme.colors.textSecondary};
    }
`;
export const DEFAULT_PREVIOUS_BUTTON_TEXT = 'previous';
export const DEFAULT_NEXT_BUTTON_TEXT = 'next';
const Paginator = ({ currentPage, totalPages, onPreviousClick, onNextClick, previousButtonText = DEFAULT_PREVIOUS_BUTTON_TEXT, nextButtonText = DEFAULT_NEXT_BUTTON_TEXT }) => {
    if (!totalPages) {
        return null;
    }
    return (React.createElement(FlexContainer, null,
        React.createElement(PreviousButtonContainer, null,
            React.createElement(Button, { "data-testid": "Paginator-previous-button", color: "primary", disabled: currentPage === 1, startIcon: React.createElement(NavigateBeforeIcon, null), onClick: onPreviousClick }, previousButtonText)),
        React.createElement(PageDetails, null,
            React.createElement("p", null,
                "page ",
                currentPage,
                " of ",
                totalPages)),
        React.createElement(NextButtonContainer, null,
            React.createElement(Button, { "data-testid": "Paginator-next-button", color: "primary", disabled: currentPage > totalPages - 1, endIcon: React.createElement(NavigateNextIcon, null), onClick: onNextClick }, nextButtonText))));
};
export default Paginator;
//# sourceMappingURL=index.js.map